import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

const ProtocoloMassaModalForm = ({
    labelType,
    onClose,
    onSend,
    isOpen
}) => {
    const [numerosDossies, setNumerosDossies] = useState('');

    const onSubmit = (e) => {
        e.preventDefault();
        const numerosList = !!numerosDossies
            ? numerosDossies.replace(/[\n|;]/g,',')
                .split(',')
                .map(item => item.replace(/\D/g,'')).filter(item => !!item)
            : [];

        if (!numerosList.length) {
            toast.error(`Digite pelo menos 1 ${labelType}.`);
            return;
        }

        !!onSend && onSend(numerosList);
        setNumerosDossies('');
    };

    const onCancel = () => {
        setNumerosDossies('');
        !!onClose && onClose();
    };

    const textoSeparador = `um ${labelType.toLowerCase()} do outro`;

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader className="modal-header--info modal-header-protocolo-massa">Protocolo em massa</ModalHeader>
            <Form name="protocoloEmMassa" noValidate onSubmit={onSubmit}>
                <ModalBody>
                    <Row>
                        <Col sm="12">
                            <Label htmlFor="iptNumerosDossies">
                                Informe abaixo a relação de {labelType.toLowerCase()}s para geração do protocolo em massa.
                            </Label>
                        </Col>
                        <Col sm="12">
                            <Input
                                type="textarea"
                                id="iptNumerosDossies"
                                name="numerosDossies"
                                rows="12"
                                value={numerosDossies}
                                onChange={(e) => setNumerosDossies(e.target.value.replace(/[^;,\n\d]/g,''))}
                                required
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col sm="12">
                            <Label className="text-muted">
                            Utilizar uma das seguintes opções para separar {textoSeparador} (;) (,) (Separação da linha - Enter).
                            </Label>
                        </Col>
                        <Col sm="12" className="text-right">
                            <Button
                                type="button"
                                color="danger"
                                className="btn_danger"
                                onClick={onCancel}
                            >Cancelar</Button>
                            <Button
                                type="submit"
                                color="primary"
                                disabled={!numerosDossies}
                            >Adicionar</Button>
                        </Col>
                    </Row>

                </ModalFooter>
            </Form>
        </Modal>
    );
};

export { ProtocoloMassaModalForm };
